import React from "react";

const Footer = () => {
  return (
    <div className="footer">
      <div className="copyright">
        <p>
          Copyright © All Rights Reserved By Pushyy App.
        </p>
      </div>
    </div>
  );
};

export default Footer;
